import React, { useState } from "react";
import { Select, MenuItem, Button, Grid, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { SelectChangeEvent } from "@mui/material/Select";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

interface DocumentFilterContentProps {
  onApplyFilter?: (state: string | null, date: Date | null) => void;
  status: string | null;
  date: Date | null;
}

const DocumentFilterContent: React.FC<DocumentFilterContentProps> = ({
  onApplyFilter,
  status,
  date,
}) => {
  const [selectState, setSelectState] = useState<string | null>(status ?? null);
  const [selectedDate, setSelectedDate] = useState<Date | null>(date ?? null);

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    setSelectState(event.target.value);
  };

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };

  const handleSubmit = () => {
    if (onApplyFilter) {
      onApplyFilter(selectState, selectedDate);
    }
  };

  return (
    <Grid container spacing={2} p={2}>
      <Grid item xs={12}>
        <Typography variant="h6" fontSize="1rem" mb={1}>
          Stato:
        </Typography>
        <Select
          fullWidth
          value={selectState ?? undefined}
          onChange={handleSelectChange}
        >
          <MenuItem value="OPEN">Aperto</MenuItem>
          <MenuItem value="CLOSED">Chiuso</MenuItem>
        </Select>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h6" fontSize="1rem" mb={1}>
          Data:
        </Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label={"Seleziona una data"}
            value={selectedDate}
            onChange={(date) => handleDateChange(date)}
            sx={{ width: "100%" }}
          />
        </LocalizationProvider>
      </Grid>

      <Grid item xs={12} textAlign="end">
        <Button fullWidth variant="contained" onClick={handleSubmit}>
          Applica filtro
        </Button>
      </Grid>
    </Grid>
  );
};

export default DocumentFilterContent;
